import AuthenticityIcon from 'assets/icons/colorful/AuthenticityIcon'
import CommentsIcon from 'assets/icons/colorful/CommentsIcon'
import EngagementsIcon from 'assets/icons/colorful/EngagementsIcon'
import FollowersIcon from 'assets/icons/colorful/FollowersIcon'
import LikesIcon from 'assets/icons/colorful/LikesIcon'
import ViewsIcon from 'assets/icons/colorful/ViewsIcon'
import FormFieldIcon from 'assets/icons/FormFieldIcon'
import NichesIcon from 'assets/icons/NichesIcon'
import React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { RootState } from 'store'
import { CampaignApplication } from 'types/campaign/applications'
import { IGSocialAccount, InfluencerInsights, SocialAccount } from 'types/influencer'
import { formatListAsString, formatNumber, formatTime } from 'utils/helpers'

const AccountDetails: React.FC<{ socialAccount: SocialAccount }> = ({ socialAccount }) => {
    const platform = socialAccount?.platform;
    const niches = useSelector((state: RootState) => state.auth.master?.niche_list) ?? {};
    return (
        <div className='detail-card border-1'>
            <div className="detail-card-header">
                Account Details
            </div>
            <div className="detail-card-body p-3">
                <div className="row g-2">
                    <div className="col-xl-4 col-md-6">
                        <div className="inf-stat-card bg-pink-light">
                            <LikesIcon />
                            {/* <span className="inf-stat-card-icon bg-pink"><i className='mdi mdi-cards-heart-outline text-white' /></span> */}
                            <span className="inf-stat-card-value">
                                {
                                    platform === 'ig' ? (socialAccount?.ig?.averages?.likes ? formatNumber(socialAccount?.ig?.averages.likes) : "NA")
                                        : platform === 'yt' ? (socialAccount?.yt?.averages?.likes ? formatNumber(socialAccount?.yt?.averages.likes) : "NA")
                                            : "NA"
                                }
                            </span>
                            <span className="inf-stat-card-label">AVG LIKES</span>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="inf-stat-card bg-yellow-light">
                            <CommentsIcon />
                            {/* <span className="inf-stat-card-icon bg-orange"><i className='mdi mdi-comment-processing text-white' /></span> */}
                            <span className="inf-stat-card-value">
                                {
                                    platform === 'ig' ? (socialAccount?.ig?.averages?.comments ? formatNumber(socialAccount?.ig?.averages.comments) : "NA")
                                        : platform === 'yt' ? (socialAccount?.yt?.averages?.comments ? formatNumber(socialAccount?.yt?.averages.comments) : "NA")
                                            : "NA"
                                }
                            </span>
                            <span className="inf-stat-card-label">Avg Comments</span>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="inf-stat-card bg-purple-light">
                            <ViewsIcon />
                            {/* <span className="inf-stat-card-icon bg-purple"><i className='mdi mdi-eye-outline text-white' /></span> */}
                            <span className="inf-stat-card-value">
                                {
                                    platform === 'ig' ? (socialAccount?.ig?.averages?.views ? formatNumber(socialAccount?.ig?.averages.views) : "NA")
                                        : platform === 'yt' ? (socialAccount?.yt?.averages?.views ? formatNumber(socialAccount?.yt?.averages.views) : "NA")
                                            : "NA"
                                }
                            </span>
                            <span className="inf-stat-card-label">Avg Views</span>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="inf-stat-card bg-orange-light">
                            <EngagementsIcon />
                            {/* <span className="inf-stat-card-icon bg-yellow"><i className='mdi mdi-chart-line text-white' /></span> */}
                            <span className={`inf-stat-card-value text-${socialAccount?.engagement_rate_details?.color}`}>{socialAccount?.engagement_score ? socialAccount.engagement_score : 'NA'}</span>
                            <span className="inf-stat-card-label">Engagement</span>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="inf-stat-card bg-skyblue-light">
                            <FollowersIcon />
                            {/* <span className="inf-stat-card-icon bg-skyblue"><i className='mdi mdi-human-male-female text-white' /></span> */}
                            <span className="inf-stat-card-value">
                                {
                                    platform === 'ig' ? (socialAccount?.ig?.followers_count ? formatNumber(socialAccount?.ig?.followers_count) : "NA")
                                        : platform === 'yt' ? (socialAccount?.yt?.subscriber_count ? formatNumber(socialAccount?.yt?.subscriber_count) : "NA")
                                            : "NA"
                                }
                            </span>
                            <span className="inf-stat-card-label">Followers/Subscribers</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AccountDetails